import React from 'react'
import PropTypes from 'prop-types'
import P from '../Typography/P'
import dictionary from '../../../dictionary'

import styles from './radio-group.module.scss'
import LegendsRadioGroup from './LegendsRadioGroup'
import LegendsTooltip from './LegendsTooltip'

function FrameType(props) {
  const { onChange, name, current, content } = props
  return (
    <div className={styles.root}>
      <P size="small" className={styles.legend}>
        Рамки в наличии
      </P>
      <LegendsRadioGroup
        defaultValue={current}
        value={current}
        ariaLabel={name}
        className={styles.group}
        onChange={(value) => onChange(name, value)}
      >
        {content.map(({ value, label, disabled }) => (
          <LegendsTooltip
            key={`${name}-${value}`}
            title={dictionary.item.frameType[value]}
          >
            <span
              className={
                value === `no_frame` ? styles.label : styles.labelBigImage
              }
              style={
                value === `no_frame` ? {} : { backgroundImage: `url(${label})` }
              }
              key={`${name}-${value}`}
              disabled={disabled}
            >
              {value === `no_frame` ? `Без рамки` : ``}
            </span>
          </LegendsTooltip>
        ))}
      </LegendsRadioGroup>
    </div>
  )
}

FrameType.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default FrameType
